<template>
  <div class="l-modal" v-if="modelValue">
    <div :class="[regist ? '' : 'l-modal__bg']">
    </div>
    <div class="form">
      <div class="close" @click="cancel()"></div>
      <div v-if="modelValue" class="information">
        <p>OMOT Influencerをご利用になる前に</p>
        <p>利用規約及びプライバシーポリシーを確認の上、</p>
        <p>同意が必要です</p>
      </div>
      <div class="mypage__list" v-if="!loading">
        <div v-for="(item, index) in itemList" :key="index" class="list__item">
          <input
            id="checkbox"
            v-model="item.checked"
            name="checkbox"
            type="checkbox"
            style="margin-right: 30px"
          />
          <p @click="push(item.link, item.page)">{{ item.name }}</p>
          <img
            class="detail_icon"
            src="../assets/detail.svg"
            @click="push(item.link, item.page)"
          />
        </div>
      </div>
      <div class="footer">
        <div
          class="btn"
          :class="[isChecked() ? 'active' : 'inactive']"
          @click="isChecked() ? agree() : ''"
          v-if="!loading"
        >
          <div>
            <p>利用規約とプライバシーポリシーに</p>
            <p>同意する</p>
          </div>
        </div>
        <div v-else>
          <img src="../assets/loading.gif" class="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import liff from "@line/liff";
import { UserInfoStore } from "../store/UserInfoStore";
import { ProjectStore } from "../store/ProjectStore";

import { signIn } from "../services/UserInfoService";
const regist = ref(false);
const loading = ref(true);
const router = useRouter();
const userInfoStore = UserInfoStore();
const projectStore = ProjectStore();

interface Emits {
  (e: "update:modelValue", value: boolean): void;
}
const emit = defineEmits<Emits>();

function isChecked() {
  const res = itemList.value.find((v) => v.checked == false);
  if (res) return false;
  else return true;
}
function cancel() {
  // windowを閉じる
  liff.closeWindow();
}

// ページ遷移
function push(link: boolean, page: string) {
  if (link) {
    window.open(page);
  } else {
    router.push(page);
  }
}

async function agree() {
  // lineのトークンの情報だけ登録
  loading.value = true;
  await userInfoStore
    .signUp()
    .then(async () => {
      await signIn(true)
      await userInfoStore.getUserDetail();
      await projectStore.getNotification()
      await userInfoStore.getBankInfo()
      await userInfoStore.getUserSnsAccount()
    }).then(() => {
      loading.value = false;
      emit("update:modelValue", false);
    });
}

const itemList = ref([
  { name: "利用規約", page: "/terms-of-use", link: false, checked: false },
  {
    name: "プライバシーポリシー",
    page: "https://fisminc.com/privacy-policy/",
    link: true,
    checked: false,
  },
]);

onMounted(async () => {
  loading.value = false;
});

export type ModalProps = {
  modelValue: boolean;
};

defineProps<ModalProps>();
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";
.information {
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_S;
  line-height: 14px;
  align-items: center;
  text-align: center;
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  > div {
    width: 100%;
    position: fixed;
    bottom: 64px;
    text-decoration-line: underline;
    color: $white;
    font-weight: 300;
    font-size: $FONT_SIZE_M;
  }
}
.mypage__list {
  width: 100%;
  max-width: 315px;
  margin: 0 auto;
}
.list__item {
  max-width: 315px;
  @include menu-list-item();
  padding-left: 0;
  border-bottom: 1px solid #d9d9d9;
  p {
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;
    text-align: left;
  }
}
.list__item:nth-child(1) {
  border-top: 1px solid #d9d9d9;
}
.footer {
  max-width: 315px;
  width: 100%;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  // position: fixed;
  // bottom: 50px;
  padding-top: 21px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}

/* ==================================
// モーダル
// ==================================*/
/* レイアウト */
.l-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}

.loading {
  width: 10%;
  height: 10%;
}

/* モーダルのサイズなど */
.form {
  width: 80%;
  max-width: 480px;
  height: 310px;
  overflow-y: auto;
  background: $white;
  border-radius: 3px;
  padding: 10px 25px;
  box-sizing: border-box;
  position: relative;
  text-align: center;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.form::-webkit-scrollbar {
  display: none;
}

/* ==================================
// ボタン
// ==================================*/
.btn {
  position: relative;
  text-align: center;
  height: 56px;
  margin: 0 auto;
  p:nth-child(1) {
    font-size: $FONT_SIZE_XS;
    padding: 7px 0 0 0;
  }
  p {
    line-height: 21px;
    text-decoration: none;
    font-weight: 500;
    margin: 0;
  }
  border-radius: 1px;
}
.active {
  background: $OMOT_COLOR;
  p {
    color: $white;
  }
}
.inactive {
  background: grey;
  p {
    color: $white;
  }
  border: 1px solid grey;
}
input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #086eb6;
  background-color: #ffffff;
  border-radius: 2px;
}
input[type="checkbox"]::before {
  content: url("../assets/checkbox.svg");
  visibility: hidden;
  background-color: #ffffff;
  vertical-align: middle;
  border: 1px solid #086eb6;
}
input[type="checkbox"]:checked::before {
  visibility: visible;
  background-color: #086eb6;
  border: 1px solid #086eb6;
}
.close {
  position: absolute;
  display: block;
  right: 0px;
  top: 0px;
  width: 9px;
  height: 9px;
  padding: 15px;
}
.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 14px;
  background: #333;
}
.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

</style>
